module.exports = __webpack_public_path__ + "img/code2.3400ff62.png";